import { createFileRoute } from '@tanstack/react-router';
import { UserGuide } from '@/features/content/Guide';

export const Route = createFileRoute('/_app/user-guide')({ component: UserGuide });
